import { OrderSystems } from './../../../models/ss-api/responses/sales.item';
import { Component, OnInit } from '@angular/core';
import { SalesItemArray } from '../../../models/ss-api/responses/sales.item';
import { SalesStatsRequest } from '../../../models/ss-api/requests/sales.stats.request';
import { BillingCycleTypes } from '../../../models/domain/invoice';
import { ssApiService } from '../../../services/ss-api.service';
import { Router } from '@angular/router';
import { LicenseManager } from '../../../managers/License.manager';
import { SortBot } from '../../../../app/helpers/sort';

@Component({
    selector: 'order-report',
    templateUrl: './order.report.component.html',
    styleUrls: ['./order.report.component.css']
})
export class OrderReportComponent implements OnInit {

    IsBusy: boolean = false;


    RecentSales: SalesItemArray = new SalesItemArray;
    Reactivations: SalesItemArray = new SalesItemArray;
    LicenseManager: LicenseManager = new LicenseManager();

    OrderReportSearch: string;

    constructor(private api: ssApiService, private router: Router) { }

    ngOnInit() {

        this.GetSalesReports();

    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    onLicenseClick(key: string) {

        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetSalesReports();
        });

    }

    GetSalesReports() {

        this.IsBusy = true;

        let request = new SalesStatsRequest();

        let dateStart = new Date();
        dateStart.setDate(dateStart.getDate() - 3);

        request.DateStart = dateStart;
        request.DateStop = new Date();
        request.IncludeFree = false;
        request.BillingCycle = BillingCycleTypes.NotDefined;

        let subscription = this.api.StatisticsSales(request).subscribe(response => {
            subscription.unsubscribe();

            this.IsBusy = false;

            if (!response.Result) {
                return;
            }

            this.RecentSales = <SalesItemArray>[...response.Data.ReactivationItems, ...response.Data.SalesItems];
            this.Reactivations = response.Data.ReactivationItems;
            this.sortByDate();
        }, error => {
            this.IsBusy = false;
        });

    }

    IsReactivation(item): boolean {
        if (this.Reactivations.indexOf(item) > -1) {
            return true;
        } else {
            return false;
        }
    }

    NameForStatus(status: number): String {
        switch (status) {
            case 0:
                return 'Open';
            case 1:
                return 'Registered';
            case 2:
                return 'Cancelled';
            case 3:
                return 'Cancelled - Open';
            case 4:
                return 'Disabled';
            case 5:
                return 'Transferred';
            case 99:
                return 'Terminated';
            case 100:
                return 'Does Not Exist';
            default:
                return 'Unkown';
        }
    }

    NameForOrderSystem(type: OrderSystems) {
        switch (type) {
            case 0:
                return 'Unkown';
            case 1:
                return 'Order Form';
            case 2:
                return 'Member Panel';
            case 3:
                return 'SSDB';
            default:
                return 'Unkown';
        }
    }

    // ////////////////////////////////////
    // SORT STUFF
    // ////////////////////////////////////

    sortByDate() { SortBot.SortAuto(this.RecentSales, 'DateTimeCreated'); }
    sortByName() { SortBot.SortAuto(this.RecentSales, 'MemberName'); }
    sortByCompany() { SortBot.SortAuto(this.RecentSales, 'CompanyName'); }
    sortByCDKey() { SortBot.SortAuto(this.RecentSales, 'LicenseKey'); }
    sortBySoftwareVersion() { SortBot.SortAuto(this.RecentSales, 'SoftwareVersion'); }
    sortBySaleType() { SortBot.SortAuto(this.RecentSales, 'LeadSource'); }
    sortByProduct() { SortBot.SortAuto(this.RecentSales, 'ProductName'); }
    sortByCycle() { SortBot.SortAuto(this.RecentSales, 'BillingCycle'); }
    sortByAmount() { SortBot.SortAuto(this.RecentSales, 'Amount'); }
    sortByStatus() { SortBot.SortAuto(this.RecentSales, 'Status'); }
    sortByOrderSystem() { SortBot.SortAuto(this.RecentSales, 'OrderSystem'); }

}
